import FeeChargeIcon from "components/RevampFeedDetails/assets/FeeChargeIcon";
import React from "react";

const FeeChargeCard = ({ jobDetails }) => {
	const feeDepositObject = jobDetails?.deposit;

	return (
		<div className="bg-[#F4F2F6] p-[16px] md:bg-inherit md:pb-0 md:pt-0">
			<div className="flex items-center space-x-[8px] rounded border border-[#F3C3C8] bg-[#FBECED] p-[8px]">
				<div className="mt-[4px] [&>svg]:h-[32px] [&>svg]:w-[32px] md:[&>svg]:h-[40px] md:[&>svg]:w-[40px]">
					<FeeChargeIcon />
				</div>
				<div className="text-[#800000]">
					<p className="m-0 text-sm font-semibold leading-[24px] md:leading-[24px]">
						₹{feeDepositObject?.amount} fee charged by company HR
					</p>
					<p className="m-0 text-xs leading-[16px]">
						{feeDepositObject?.purpose}
					</p>
				</div>
			</div>
		</div>
	);
};

export default FeeChargeCard;
